import { useCallback } from "react";

import { useAppDispatch, useAppStore } from "app/redux-store-interactions";
import { undoRedoActions } from "features/undoRedo";

import { consumeMobileMenuDismissed } from "../mobileMenuDismissalFlag";
import { renderActions, selectDefaultVisibility } from "../renderSlice";

/**
 * Toggle X-ray from the toolbar or keyboard shortcut.
 *
 * Entering dismisses the context menu. While X-ray is on, the current
 * selection IDs stay frozen (see HighlightedProvider and setMainObject)
 * until X-ray is turned off.
 */
export function useToggleXRayMode() {
    const dispatch = useAppDispatch();
    const store = useAppStore();

    return useCallback(() => {
        consumeMobileMenuDismissed();

        const currentVisibility = selectDefaultVisibility(store.getState());
        dispatch(renderActions.toggleXRayMode());
        dispatch(
            undoRedoActions.push({
                description: "Toggle X-Ray mode",
                undoCallback: () => dispatch(renderActions.setVisibilityMode(currentVisibility)),
                redoCallback: () => dispatch(renderActions.toggleXRayMode()),
            }),
        );
    }, [dispatch, store]);
}
